import React from 'react';
import Markdown, {
 Components
} from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface MessageParserProps {
  text: string;
}

// Strips react-markdown's extra props (node, ref) that are incompatible with native HTML elements
const clean = <T extends Record<string, any>>({ node, ref, ...rest }: T) => rest;

const MessageParser: React.FC<MessageParserProps> = ({
 text
}) => {
  const customComponents: Components = {
    a: ({
  ref, node, ...props
}) => (
    <a {...props} target="_blank" rel="noopener noreferrer">
        {props.children}
    </a>
    ),
    h1: ({
 ref, node, ...props
}) => (
    <h1 className="font-bold mb-3" {...props} />
    ),
    h2: ({
 ref, node, ...props
}) => (
    <h2
        className="font-semibold mt-2"
        style={{ color: '#457b9d' }}
        {...clean(props)}
      />
    ),
    h3: ({
 ref, node, ...props
}) => (
    <h3
        className="font-semibold mt-2"
        style={{ color: '#457b9d' }}
        {...clean(props)}
      />
    ),
    code: ({
 children, className, ref, node, ...props
}) => {
      const inline = !className;
      return (
    <code
        style={{
          backgroundColor: inline ? '#f1f1f1' : '#282c34',
          color: inline ? '#000' : '#61dafb',
          padding: '4px 8px',
          borderRadius: '5px',
          display: inline ? 'inline' : 'block',
        }}
        {...clean(props)}
      >
        {children}
    </code>
      );
    },
    img: ({
 ref, node, ...props
}) => (
    <img
        style={{
          maxWidth: '100%',
          borderRadius: '8px',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        }}
        {...clean(props)}
      />
    ),
    table: ({
 ref, node, ...props
}) => (
    <table
        style={{
          borderCollapse: 'collapse',
          width: '100%',
        }}
        {...clean(props)}
      />
    ),
    th: ({
 ref, node, ...props
}) => (
    <th
        style={{
          backgroundColor: '#457b9d',
          color: 'white',
          padding: '10px',
          border: '1px solid #ddd',
        }}
        {...clean(props)}
      />
    ),
    td: ({
 ref, node, ...props
}) => (
    <td
        style={{
          padding: '10px',
          border: '1px solid #ddd',
        }}
        {...clean(props)}
      />
    ),
  };

  return (
      <Markdown
      className="custom-markdown-webChat"
      components={customComponents}
      remarkPlugins={[remarkGfm]}
    >
          {text}
      </Markdown>
  );
};

export default MessageParser;
